module.exports = __webpack_public_path__ + "img/icon-ubicacion.e9f0d4b9.svg";